module.exports = __webpack_public_path__ + "img/Unidad21-2.4ea80dcd.png";